import {_} from "vue-underscore"
import {mapActions, mapGetters} from 'vuex'
import {
  REQUIRED_RAIL_ROD_PARAMETERS, TRACK_RAIL,
} from "@/constants"
import priceEndpoints from "@/api/prices"
import {tryExceptAwait} from "@/utils"

export default {
  computed: {
    ...mapGetters({
      curtainType: 'order/getCurtainType',
      railRodType: 'order/getRailRodType',
      railRodParameters: 'order/getRailRodParameters',
      railRodTemplate: 'order/getRailRodTemplate'
    }),
    requiredRailRodParameters() {
      // make sure to clone the required parameters by slicing to prevent
      // modifying the reference to the same array
      return (REQUIRED_RAIL_ROD_PARAMETERS[this.railRodType] || []).slice()
    }
  },
  methods: {
    ...mapActions({
      setRailRodPriceData: 'order/setRailRodPriceData'
    }),
    async fetchRailRodPriceData() {
      if (!this.requiredRailRodParameters.length) {
        // missing or empty parameters for this rail rod type, stop
        return null
      }
      // are there required rail rod parameters missing in the flow data?
      const missingRailRodParameters = _.difference(
        this.requiredRailRodParameters,
        Object.keys(this.railRodParameters)
      )
      if (
        missingRailRodParameters.length > 0
        || this.railRodParameters.length < 20
      ) {
        // still rail rod parameters missing, stop
        return null
      }
      // now fetch given the rail rod type and rail rod parameters
      this.$wait.start('isLoadingRailRodPrice')
      const params = {
        ...this.railRodParameters,
        ...(this.railRodType === TRACK_RAIL
          ? { rail_curtain_type: this.curtainType }
          : {})
      }
      const {data, status} = await tryExceptAwait(
        priceEndpoints.getProductPrice,
        [
          {articleType: this.railRodType},
          _.pick(params, (value) => value !== null)
        ]
      )
      // save rail rod price to vuex store or reset it on error response
      this.setRailRodPriceData(status === 200 ? data : {})
      this.$wait.end('isLoadingRailRodPrice')
    },
  }
}
